module.exports = __webpack_public_path__ + "img/tutorial_JT.d0511acb.png";